import React, { useState, useEffect } from "react";
import BillingHistoryTable from "./BillingHistoryTable";
import { SortConfig } from "../ui/paginated-table";

interface Invoice {
  id: string;
  status: "Paid" | "Pending" | "Failed";
  amount: number;
  created: string;
}

const BillingHistory: React.FC = () => {
  const [invoices, setInvoices] = useState<Invoice[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [sortConfig, setSortConfig] = useState<SortConfig<Invoice>>({ key: null, direction: "desc" });
  
  const pageSize = 10;

  useEffect(() => {
    // Simulating API call to fetch invoices
    setTimeout(() => {
      setInvoices([]);
      setIsLoading(false);
    }, 1000);
  }, []);

  const handleViewInvoice = (invoice: Invoice) => {
    // Handle viewing invoice details
    console.log("Viewing invoice:", invoice);
    // You could open a modal, navigate to a new page, or download the invoice
  };

  const handleSort = (key: keyof Invoice) => {
    let direction: "asc" | "desc" = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-gc-med text-foreground">Billing History</h3>
        <p className="text-sm text-muted-foreground">Showing invoices within the past 12 months</p>
      </div>
      
      <BillingHistoryTable
        invoices={invoices}
        loading={isLoading}
        onViewInvoice={handleViewInvoice}
        emptyTitle="No billing history"
        emptyDescription="No invoices have been generated yet."
        currentPage={currentPage}
        onPageChange={handlePageChange}
        pageSize={pageSize}
        sortConfig={sortConfig}
        onSort={handleSort}
        showPagination={true}
      />
    </div>
  );
};

export default BillingHistory;
